import { gql } from '__generated__';

export default gql(`
  query GetRegistrationsForSale($id: ID!, $tickets: [String!], $limit: Int!, $invitation_code: String) {
    event(id: $id) {
      id
      registrations_for_sale_count
      filtered_registrations_for_sale_count: registrations_for_sale_count(tickets: $tickets)
      sold_registrations_count
      enable_waitlist
      waitlist_size
      ticket_categories(invitation_code: $invitation_code) {
        id
        title
        resellable_tickets {
          id
          title
          cached_registrations_for_sale_count
        }
      }
      registrations_for_sale(tickets: $tickets, limit: $limit) {
        id
        ticket {
          id
          title
          units
        }
        start_time
        corral_name
        time_slot {
          id
          start_date
          start_time
          title
          multi_date
        }
        promotion {
          id
          title
        }
        resale {
          id
          available
          total_amount
          fee
          public_url
          public_token
          upgrades {
            id
            product {
              id
              title
              type
            }
            product_variant {
              id
              title
            }
          }
        }
      }
    }
  }
`);
